import { Button } from "@/components/ui/button"
import { useEffect, useState } from "react"
import { SHOW_PROMO_BANNER } from "@/config/promoBanner"

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0)
  const images = ["/images/hero/hero-album.jpg", "/images/hero/hero-album-2.jpg"]
  const alts = [
    "Albums photo de qualité avec souvenirs familiaux",
    "Famille créant des souvenirs avec des albums photo"
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [images.length])

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden rounded-b-3xl">
      {/* Element pour tester l'état connecté - invisible */}
      <div id="logged" className="hidden"></div>
      
      {/* Background Carousel */}
      <div className="absolute inset-0 z-0 rounded-b-3xl">
        <div className="relative w-full h-full">
          {images.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image} 
                alt={alts[index]}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 from-0% via-black/15 via-40% to-transparent to-70% rounded-b-3xl"></div>
        {/* Voile noir supplémentaire pour mobile */}
        <div className="absolute inset-0 bg-black/20 md:bg-transparent rounded-b-3xl"></div>
      </div>
      
      {/* Avantages en haut à droite */}
      <div className={`absolute ${SHOW_PROMO_BANNER ? 'top-[210px]' : 'top-[160px]'} md:top-40 right-4 lg:right-8 z-10 flex flex-col gap-4 w-52 md:w-64`}>
        <a href="#albums" className="inline-block transition-all duration-300 hover:scale-110">
          <img 
            src="/images/hero/Promo_Livraison.png" 
            alt="Livraison offerte dès 50€" 
            className="w-full h-auto object-contain"
          />
        </a>
      </div>

      {/* Content */}
      <div className={`relative z-10 container mx-auto px-4 lg:px-8 ${SHOW_PROMO_BANNER ? 'pt-[166px]' : 'pt-[130px]'} md:pt-40 lg:pt-8`}>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8 animate-fade-in-up relative">
              {/* Voile noir derrière le texte pour lisibilité */}
              <div className="absolute -inset-6 bg-black/25 rounded-2xl blur-xl -z-10"></div>

            {/* Main Heading */}
            <div className="space-y-4">
              <div className="relative">
                  <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold leading-tight pb-4 text-white drop-shadow-lg">
                  Faites revivre vos plus <span className="pb-2 drop-shadow-lg" style={{color: '#f9bb72'}}>beaux moments en images</span>
                </h1>
              </div>
              <p className="text-lg md:text-xl text-white/95 max-w-lg leading-relaxed drop-shadow-md">
                Créez vos albums photo personnalisés en quelques clics. 
                Partagez vos moments précieux avec vos proches.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button variant="rainbow" size="xl" className="animate-scale-in" asChild>
                <a href="#albums">Créer mon album 🎁</a>
              </Button>
            </div>

          </div>

          {/* Floating Elements - Visual Interest */}
          <div className="relative hidden lg:block">
            <div className="absolute inset-0 animate-float">
              <div className="absolute top-10 right-10 w-16 h-16 bg-primary/10 rounded-full blur-xl animate-pulse"></div>
              <div className="absolute bottom-20 left-10 w-24 h-24 bg-sage-green/10 rounded-full blur-xl animate-pulse delay-1000"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Indicators */}
      <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20 justify-center w-full">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide 
                ? 'bg-[#f9bb72] shadow-lg scale-110' 
                : 'bg-[#f9bb72]/30 hover:bg-[#f9bb72]/60'
            }`}
            aria-label={`Aller à l'image ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
}